export default [

    {
        path: '/InstallationHomePage',
        name: 'InstallationHomePage',
        component: () => import('../../views/Installation/InstallationHomePage.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/InstallationPublishHome',
        name: 'InstallationPublishHome',
        component: () => import('../../views/Installation/InstallationPublishHome.vue'),
        meta: {
            keepAlive: true
        }

    },
    {
        path: '/InstallationPublishingNode', // 维保发布
        name: 'InstallationPublishingNode',
        component: () => import('../../views/Installation/CirculationNodes/InstallationPublishingNode.vue'),

    },
    {
        path: '/InstallationAuditNode', // 维保审核
        name: 'InstallationAuditNode',
        component: () => import('../../views/Installation/CirculationNodes/InstallationAuditNode.vue'),

    },
    {
        path: '/InstallationIssuingNode', //维保签发
        name: 'InstallationIssuingNode',
        component: () => import('../../views/Installation/CirculationNodes/InstallationIssuingNode.vue'),

    },
    {
        path: '/draftInstallationHome',
        name: 'draftInstallationHome',
        component: () => import('../../views/Installation/Installationdraft/draftInstallationHome.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/InstallationreadonlyHome',
        name: 'InstallationreadonlyHome',
        component: () => import('../../views/Installation/Installationreadonly/InstallationreadonlyHome.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/InstallationHistoryPage',
        name: 'InstallationHistoryPage',
        component: () => import('../../views/Installation/historyPage/InstallationHistoryPage.vue'),
    },
    { //文件下载
        path: '/InstallationFileDownload',
        name: 'InstallationFileDownload',
        component: () => import('../../views/Installation/Documents/InstallationFileDownload.vue'),
    },
    { //文件生成
        path: '/InstallationGenerateDocument',
        name: 'InstallationGenerateDocument',
        component: () => import('../../views/Installation/Documents/InstallationGenerateDocument.vue'),
    }

]